module.exports = __webpack_public_path__ + "img/b643d5e.jpg";